'use client';

import { c as _c } from "react/compiler-runtime";
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useLenis } from 'lenis/react';
import { useEffect, useLayoutEffect } from 'react';
export function ScrollTriggerConfig() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useLayoutEffect(_temp, t0);
  const lenis = useLenis(ScrollTrigger.update);
  let t1;
  if ($[1] !== lenis) {
    t1 = [lenis];
    $[1] = lenis;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(_temp2, t1);
  return null;
}
function _temp2() {
  return ScrollTrigger.refresh();
}
function _temp() {
  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.clearScrollMemory("manual");
  ScrollTrigger.defaults({
    markers: process.env.NODE_ENV === "development"
  });
}